var _style, _path, _path2, _polygon, _polygon2, _polygon3, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHaradyn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 115.66 81.32",
    style: {
      enableBackground: "new 0 0 115.66 81.32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1F4E8D;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.29,33.75l-4.26,24.57l-9.36,6.02l3.62-23.76c0.31-1.76,0.1-5.08-3.14-3.45l-21.16,9.32 c-2.39,1.04-4.19,3.87-4.32,6.47l-0.63,6.1c-0.63,7.74-6.75,11.2-6.75,11.2l-16,8.79c0,0,6.35-3.13,6.56-15.03l1.03-57.24 l19.17-3.28l-1.43,21.22c0,0,1.33-1.44,2.43-1.87s25.1-7.26,25.1-7.26C115.12,11.41,116.47,27.97,115.29,33.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.63,3.25l0.65,21.38c0,0-0.99-1.76-2.83-2.26c0,0-17.28-5.32-26.14-7.49C1.45,12.7,0,21.79,0,29.81 c0,10.16,6.65,29.82,15.68,35.34c0,0,16.7,10.11,24.06,14.62c7.36,4.51,17.12-1.22,18.29-12.43L58.95,6.8L38.63,3.25z M39.98,53.84 c0,3.73-1.56,5.23-4.86,3.54L15.26,48c-2.69-1.14-4.13-4.95-4.13-8.05c0-4.76,2.02-3.11,4.7-1.97l19.45,8.1 C37.97,47.22,39.98,50.75,39.98,53.84L39.98,53.84z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "7.76,13.26 38.08,21.31 37.6,13.26 25.56,10.18 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "39.98,2.37 59.63,5.57 78.93,2.37 58.95,0 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "80.47,12.79 79.88,21.31 108.29,13.85 89.23,10.89 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.91,45.23L84.48,58.5l16.12,6.04c0,0,3.2-23.09,3.43-24.16c0.24-1.07,0.47-2.37,0-2.72 C103.56,37.3,85.91,45.23,85.91,45.23z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaradyn);
export default __webpack_public_path__ + "static/media/haradyn.bbb66b21d31c8514f56110150ac8a7a6.svg";
export { ForwardRef as ReactComponent };